import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './styles.less';
import PropTypes from 'prop-types';

const InfoModal = ({ title, buttonLabel, children, buttonProps, ...props }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const hideModal = () => setModalVisible(false);
  const openModal = () => setModalVisible(true);

  const modalFooter = (
    <Button type="primary" onClick={hideModal}>
      Entendido
    </Button>
  );

  return (
    <div>
      <Button className="pep-info__button" type="link" onClick={openModal} {...buttonProps}>
        <InfoCircleOutlined /> <u className="pep-info__button__text">{buttonLabel}</u>
      </Button>
      <Modal visible={isModalVisible} onCancel={hideModal} footer={modalFooter} {...props}>
        {title && (
          <p>
            <b>{title}</b>
          </p>
        )}
        {children}
      </Modal>
    </div>
  );
};

InfoModal.propTypes = {
  title: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  buttonProps: PropTypes.shape(),
};

InfoModal.defaultProps = {
  title: undefined,
  buttonProps: {},
};

export default InfoModal;
